// @flow strict
import React from 'react';
import styles from './Content.module.scss';
import TableOfContents from '../../TableOfContents';

type Props = {
  body: string,
  title: string,
  toc: string
};

const Content = ({ body, title, toc }: Props) => (
  <div className={styles['content']}>
    <h1 className={styles['content__title']}>{title}</h1>
    <TableOfContents toc={toc} />
    <div className={styles['content__body']} dangerouslySetInnerHTML={{ __html: body }} />
  </div>
);

export default Content;
